import _extends from "@babel/runtime/helpers/extends";
import { Box, Card, SkeletonGroup, SkeletonRectangle, Text } from '@wix/design-system';
import React, { useCallback } from 'react';
import { CollapseListItem } from '../collapse-list-item';
export const CardListItem = /*#__PURE__*/React.memo(_ref => {
  let {
    title,
    subtitle,
    children,
    showShadow = false,
    isLoading,
    showTitleWhenLoading,
    disabled,
    ...rest
  } = _ref;
  const CardWrapper = useCallback(_ref2 => {
    let {
      children: cardChildren
    } = _ref2;
    return /*#__PURE__*/React.createElement(Card, {
      showShadow: showShadow
    }, /*#__PURE__*/React.createElement(Box, {
      border: "1px solid",
      borderColor: "D60",
      borderRadius: "8px",
      display: "block",
      overflow: "hidden"
    }, cardChildren));
  }, [showShadow]);
  const renderTitle = useCallback(() => {
    if (isLoading && !showTitleWhenLoading) {
      return /*#__PURE__*/React.createElement(SkeletonGroup, null, /*#__PURE__*/React.createElement(SkeletonRectangle, {
        height: "18px",
        width: "86px"
      }));
    }
    return typeof title === 'string' ? /*#__PURE__*/React.createElement(Text, {
      ellipsis: true,
      size: "small",
      weight: "bold"
    }, title) : title;
  }, [isLoading, showTitleWhenLoading, title]);
  const renderSubtitle = useCallback(() => {
    if (isLoading && subtitle) {
      return /*#__PURE__*/React.createElement(Box, {
        paddingTop: "SP1"
      }, /*#__PURE__*/React.createElement(SkeletonGroup, null, /*#__PURE__*/React.createElement(SkeletonRectangle, {
        height: "4px",
        width: "102px"
      })));
    }
    return typeof subtitle === 'string' ? /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "thin"
    }, subtitle) : subtitle;
  }, [isLoading, subtitle]);
  return /*#__PURE__*/React.createElement(CollapseListItem, _extends({
    disabled: disabled,
    headerPadding: "medium",
    subtitle: renderSubtitle(),
    title: renderTitle(),
    wrapper: CardWrapper
  }, rest), children);
});
//# sourceMappingURL=card-collapse-list-item.js.map